export const customerCompanyHeader = 'X-Customer-Company-Id';

export interface CustomerCompany {
  companyId: number;
  companyName: string;
  companyKana?: string | null;
}

export interface CustomerContext {
  canSwitchCompany: boolean;
  companyId: number;
  supportCompany?: CustomerCompany;
}
